import React, { Component } from 'react'

export class Destructrigprop extends Component {
    render() {
        return (
            <div style={{marginLeft:"150px"}}>
                <Welcome name="Ravi" lastname="Patel"></Welcome>                
                <Welcomethree name="Niki" lastname="Patel"></Welcomethree>
                <Welcomenew name="Kashish" lastname="patel"></Welcomenew>
            </div>
        )
    }
}
const Welcome=({name,lastname})=>{
    // const {name,lastname} = props
    return(
        <h1>hello {name} {lastname}</h1>
    )
}
const Welcomethree =(props)=>{
    const {name,lastname} = props
    return(
        <h1>hello {name} {lastname}</h1>
    )
}
class Welcomenew extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            Hello:"Hello",
            HowRyou:"How R you"
        }    
    }   
     render() {
        const {name,lastname} = this.props
        const {Hello,HowRyou} = this.state
        return (
            <div>
                  <h1>hello {name} {lastname}</h1>
                  <br></br>
                  {Hello} {HowRyou} ?
            </div>
        )
    }
}
export default Destructrigprop
